import { openComponentInPopup, QueryParameter } from "./common";
import Form from "./form";
import { PopupWidth } from "./popup";
import { trackGenerateLead } from "./analytics";

// Runs server-provided script content via a real <script> element instead of eval(). Same trust
// level as eval (the markup is shop-configured), but executes in global scope and is JIT-compiled
// by the engine rather than interpreted — and keeps eval() out of the bundle.
function executeScript(code: string): void {
    if (!code || !code.trim()) {
        return;
    }
    const scriptElement = document.createElement('script');
    scriptElement.text = code;
    document.body.appendChild(scriptElement);
    scriptElement.remove();
}

export class InquiryForm {
    private componentName: string = 'InquiryForm';
    private componentId: string = 'inquiry-form-popup';

    async openInPopup(event: Event, queryParameters: QueryParameter[] = null): Promise<void> {
        event?.preventDefault();

        await openComponentInPopup(this.componentName, queryParameters, { id: this.componentId, width: PopupWidth.Medium }, true);
        const scripts = document.getElementById("inquiry-external-scripts");
        executeScript(scripts.innerHTML);
        this.subscribeForm();
    }

    private subscribeForm(): void {
        const formElement = document.querySelector('[data-popup] form') as HTMLFormElement;

        const actionUrl = formElement.getAttribute('action');
        const form = new Form(actionUrl, formElement,
            (html: string) => this.onSuccess(html, formElement.id || 'inquiry-form', actionUrl),
            (html: string) => this.onModelError(html));

        form.subscribeAndProcess();
    }

    private onSuccess(script: string, formId: string, formDestination: string): void {
        this.displaySuccessMessage();
        executeScript(script);
        trackGenerateLead(formId, formDestination);
    }

    private onModelError(html: string): void {
        const viewcomponent = document.querySelector(`[data-component=${this.componentName}]`);
        viewcomponent.innerHTML = html;
        this.subscribeForm();
    }

    private displaySuccessMessage(): void {
        const successMessageElement = document.getElementById('success-message');
        const form = document.getElementById('inquiry-form');
        successMessageElement.style.display = 'block';
        form.style.display = 'none';
    }
}
